import { Injectable } from '@angular/core';
import { PpHttpParams, PpHttpService } from '@penpencil/common';
import { ErrorHandlerService } from 'app/core/services';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class OrganisationService extends ErrorHandlerService {
    constructor(private _ppHttpService: PpHttpService) {
        super();
    }

    getPrefData(organizationId: string, query = {}): Observable<any> {
        return this._ppHttpService
            .get({
                apiPath: `v1/admin/organizations/${organizationId}/preferences`,
                params: new PpHttpParams().appendAll(query),
            })
            .pipe(catchError(this.handleError));
    }

    editPrefData(data: any, organizationId: string): Observable<any> {
        return this._ppHttpService
            .put(data, {
                apiPath: `v1/admin/organizations/${organizationId}/preferences`,
            })
            .pipe(catchError(this.handleError));
    }

    assignModule(
        organizationId: string,
        roleId: string,
        data: any,
    ): Observable<any> {
        return this._ppHttpService
            .put(data, {
                apiPath: `v1/admin/organizations/${organizationId}/role/${roleId}/assign-modules`,
            })
            .pipe(catchError(this.handleError));
    }

    getPolicies(organizationId: string): Observable<any> {
        return this._ppHttpService
            .get({
                apiPath: `v1/admin/organizations/${organizationId}/policies`,
            })
            .pipe(catchError(this.handleError));
    }

    updatePolicy(policy: any, organizationId: string): Observable<any> {
        return this._ppHttpService
            .put(policy, {
                apiPath: `v1/admin/organizations/${organizationId}/policy/${policy._id}`,
            })
            .pipe(catchError(this.handleError));
    }
}
